import styles from './loading-button.module.scss';
import MaterialLoadingButton from '@mui/lab/LoadingButton';
import { AriaAttributes } from 'react';

/* eslint-disable-next-line */
export interface LoadingButtonProps extends Pick<AriaAttributes, 'aria-label' | 'aria-busy'> {
  children: any,
  // classes?: object,
  disabled?: boolean,
  loading?: boolean,
  loadingIndicator?: any,
  loadingPosition?: 'start' | 'end' | 'center',
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning',
  sx?: any,
  startIcon?: any,
  endIcon?: any,
  className?: string,
  size?: 'small' | 'medium' | 'large',
  variant?: 'contained' | 'outlined' | 'text',
  onClick?: (...args: any[]) => void,
  ['data-testid']?: string
}

export function LoadingButton(props: LoadingButtonProps) {
  return (
    <MaterialLoadingButton
      loading={props.loading}
      loadingPosition={props.loadingPosition}
      startIcon={props.startIcon}
      endIcon={props.endIcon}
      disabled={props.disabled}
      sx={{ textTransform: 'none' }}
      size={props.size}
      variant={props.variant}
      onClick={props.onClick}
      className={props.className}
      color={props.color || 'primary'}
      loadingIndicator={props.loadingIndicator}
      aria-label={props['aria-label']}
      aria-busy={props['aria-busy']}
      data-testid={props['data-testid']}>
      {props.children}
    </MaterialLoadingButton>
  );
}

export default LoadingButton;